import React from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import CameraPhoto, { FACING_MODES } from 'jslib-html5-camera-photo';
import { Spin, Icon } from 'antd';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import shotCameraIcon from '../assets/shot-camera-btn.svg';
import { FloatingButton } from '.';

const antIcon = <Icon type="loading" style={{ fontSize: 48 }} spin />;

class Camera extends React.Component {
  constructor(props) {
    super();
    this.cameraPhoto = null;
    this.videoRef = React.createRef();
    const { onImageSubmit, onTakePhoto } = props;
    this.onImageSubmit = onImageSubmit;
    this.onTakePhoto = onTakePhoto;
    this.state = {
      enabledToTakePhotos: false,
    };
  }

  componentDidMount() {
    this.cameraPhoto = new CameraPhoto(this.videoRef.current);
    this.cameraPhoto.startCamera(FACING_MODES.ENVIRONMENT, { width: 640, height: 480 }).then(() => {
      this.setState({ enabledToTakePhotos: true });
    });
  }

  componentWillUnmount() {
    this.stopCamera();
  }

  takePhoto() {
    const { enabledToTakePhotos } = this.state;
    const { currentPhoto } = this.props;
    if (enabledToTakePhotos && currentPhoto === undefined) {
      const config = {
        sizeFactor: 1,
      };

      const dataUri = this.cameraPhoto.getDataUri(config);
      const esUnDataUriValido = dataUri !== undefined && dataUri.length > 10;
      if (esUnDataUriValido) {
        this.onTakePhoto(dataUri);
      }
    }
  }

  stopCamera() {
    this.cameraPhoto.stopCamera()
      .then(() => {
      })
      .catch((error) => {
      });
  }

  startCamera(idealFacingMode, idealResolution) {
    const self = this;
    this.cameraPhoto.startCamera(idealFacingMode, idealResolution)
      .then(() => {
        console.log('CAMERA STARTED !!!');
        self.setState({ enabledToTakePhotos: true });
      })
      .catch((error) => {
        console.error('Camera not started!', error);
      });
  }

  render() {
    const { inProgress, currentPhoto } = this.props;
    const { enabledToTakePhotos } = this.state;

    let shotCameraClasses = '';
    shotCameraClasses += ' camera-take-photo-button';

    if (currentPhoto || !enabledToTakePhotos) {
      shotCameraClasses += ' camera-take-photo-button-hidden';
    }
    return (
      <div className="camera">
        <img
          style={{ height: 'auto', width: '100%', display: (currentPhoto) ? 'block' : 'none' }}
          alt="imgCamera"
          src={currentPhoto}
        />
        <div style={{ display: (inProgress !== true) ? 'block' : 'none' }}>
          <video
            style={{
              height: 'auto', width: '100%', background: 'black', display: (currentPhoto) ? 'none' : 'block',
            }}
            ref={this.videoRef}
            autoPlay
          />
          {/*
          <div className="camera-top-buttons" style={{ display: (currentPhoto) ? 'inline-block' : 'none' }}>
            <div className="camera-top-bar" />
            <button
              className="camera-cancel-photo-button"
              onClick={() => {
                const { onDiscardPhoto } = this.props;
                onDiscardPhoto();
              }}
            >
              <FontAwesomeIcon color="#000000" icon={faArrowLeft} />
            </button>
          </div> */}

          <button
            type="button"
            className={shotCameraClasses}
            onClick={() => {
              this.takePhoto();
            }}
          >
            <img alt="Shot Camera" className="camera-icon" src={shotCameraIcon} />
          </button>
          { currentPhoto ? <FloatingButton icon={faPlus} onClick={() => this.onImageSubmit(currentPhoto)} /> : null}
        </div>
        <div style={{ display: (inProgress !== true) ? 'none' : 'block' }} className="camera-upload-spinner"><Spin size="large" style={{ background: 'white', borderRadius: '50%' }} indicator={antIcon} /></div>
      </div>
    );
  }
}
export default Camera;
